export enum HighContrastMode {
  DISABLED,
  LIGHT,
  DARK,
}

export const HighContrastTokens = {
  light: {
    cssClass: 'high-contrast-light',
    themeUrl: 'High_Contrast_Light',
  },
  dark: {
    cssClass: 'high-contrast-dark',
    themeUrl: 'High_Contrast_Dark',
  },
};
